import React,{ useCallback, useContext } from 'react';
import logo from '../utils/img/dyb.png';
import './css/styles.css'
import {Form,Input,Button } from 'antd';
import {withRouter,Redirect} from 'react-router'
import app from '../utils/base';
import { AuthContext } from '../context/Auth';

import {useForm, Controller} from 'react-hook-form';

const LoginPage = ({history}) => {
    const {handleSubmit,control}=useForm();
    // eslint-disable-next-line
    const resetPassword=()=>{
        history.push("reset")
    }// eslint-disable-next-line
    const onSubmit=useCallback(
        async data=>{

            const {email,password}=data;
            try {

                await app
                        .auth()
                        .signInWithEmailAndPassword(email,password);
                history.push('/');
            }catch (err){
            alert('Correo o Contraseña invalidos');
            }

        }
    )     
    

    const {currentUser}= useContext(AuthContext);
    if (currentUser){
        return <Redirect to="/"/>
    }
    return (
    <div className="container">
        <img className="imagen" src={logo} alt="logo"/>
        <div className="form-login">
        <Form
                layout='vertical'
                size='large'
                style={{height:'100%'}}
                onSubmitCapture={handleSubmit(onSubmit)}
            >
                <Form.Item >
                <Controller placeholder="email" as={Input} type='email' name="email" control={control} />
                </Form.Item>
                <Form.Item >
                <Controller placeholder="password" as={<Input.Password  rules={[
                    {
                        required: true,
                        message: 'Please input your password!',
                    },
                    ]}/>}  name="password" control={control} />
                </Form.Item>
                <Form.Item>
                    <Button type='link' onClick={resetPassword} >
                        He olvidado mi contraseña
                    </Button>

                </Form.Item>
                
                <Button type="primary" htmlType='submit'>
                    Iniciar Sesión
                </Button>
          </Form>
        </div>  
    </div>
    );
}
 
export default withRouter(LoginPage);